import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

const routeList = [
  { path: "/pembekalan-wisuda/scan", label: "Scan QR Pembekalan Wisuda" },
  { path: "/pembekalan-wisuda/self-check-in", label: "Self Check-in Pembekalan Wisuda" },

//   { path: "/openhouse/qr", label: "Scan QR Open House" },
//   { path: "/openhouse/cek", label: "Cek Data Open House" },
//   { path: "/openhouse/self-check-in", label: "Self Check-In Open House" },

//   { path: "/gathering-repeat-info-search", label: "Cek Data Gathering" },
//   { path: "/self-check-in-gathering-upi-yptk-2025", label: "Self Check-In Gathering" },
//   { path: "/scan-qr-gathering-2025", label: "Scan QR Gathering" },

];

const Home = () => {
    const navigate = useNavigate();
  
    return (
      <div className="home-container">
        <div className="home-card">
          <h1 className="home-title">🎓 Event Portal</h1>
          <p className="home-subtitle">Pilih salah satu menu di bawah ini</p>
          <div className="button-grid">
            {routeList.map((route, index) => (
              <button
                key={index}
                className="home-button"
                onClick={() => navigate(route.path)}
              >
                {route.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  };
  
  export default Home;
